// Hash de PIN 4 dígitos — client-side only.
// Guardamos SHA-256(pin + salt_funcionario) no localStorage. O JWT já está
// armazenado também — o PIN é só um lock VISUAL antes do dashboard.
// Se o celular for roubado, o localStorage inteiro pode ser lido — o PIN
// NÃO é defesa criptográfica, apenas conveniência (como no WhatsApp/banco).

const PIN_KEY = "digiponto_app_pin";
const SALT_KEY = "digiponto_app_pin_salt";
const FAIL_KEY = "digiponto_app_pin_fails";
const MAX_FAILS = 3;

async function sha256(text) {
  const buf = new TextEncoder().encode(text);
  const hash = await crypto.subtle.digest("SHA-256", buf);
  return Array.from(new Uint8Array(hash))
    .map((b) => b.toString(16).padStart(2, "0")).join("");
}

function getSalt() {
  let s = localStorage.getItem(SALT_KEY);
  if (!s) {
    s = Array.from(crypto.getRandomValues(new Uint8Array(16)))
      .map((b) => b.toString(16).padStart(2, "0")).join("");
    localStorage.setItem(SALT_KEY, s);
  }
  return s;
}

export const appPin = {
  isSet: () => !!localStorage.getItem(PIN_KEY),

  set: async (pin) => {
    if (!/^\d{4}$/.test(pin)) throw new Error("PIN deve ter 4 dígitos");
    const salt = getSalt();
    const h = await sha256(pin + salt);
    localStorage.setItem(PIN_KEY, h);
    localStorage.setItem(FAIL_KEY, "0");
  },

  verify: async (pin) => {
    const stored = localStorage.getItem(PIN_KEY);
    if (!stored) return true; // no PIN set = always ok
    const salt = getSalt();
    const h = await sha256(pin + salt);
    const ok = h === stored;
    if (!ok) {
      const fails = Number(localStorage.getItem(FAIL_KEY) || "0") + 1;
      localStorage.setItem(FAIL_KEY, String(fails));
      if (fails >= MAX_FAILS) {
        // Após 3 falhas, apaga o PIN — exige login completo
        localStorage.removeItem(PIN_KEY);
        localStorage.removeItem(FAIL_KEY);
        throw new Error("Muitas tentativas erradas. Faça login novamente.");
      }
      throw new Error(`PIN incorreto — ${MAX_FAILS - fails} tentativa(s) restante(s)`);
    }
    localStorage.setItem(FAIL_KEY, "0");
    return true;
  },

  clear: () => {
    localStorage.removeItem(PIN_KEY);
    localStorage.removeItem(FAIL_KEY);
  },

  failsRemaining: () => MAX_FAILS - Number(localStorage.getItem(FAIL_KEY) || "0"),
};
